import React from 'react';
export const DashKetcher = React.lazy(() => import(/* webpackChunkName: "DashKetcher" */ './fragments/DashKetcher'));